import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Button from 'src/components/atoms/button/button';
import { Form, FormError, FormItem, FormRow } from 'src/components/atoms/form';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { validationSchema } from 'src/utils/validation-utils';
import { Switcher } from 'src/components/atoms/switcher/switcher';
import { loginData } from 'src/utils/auth-utils';
import { LoginData } from 'src/models/login.model';
import { doLogin } from '../../../reducers/authentication.reducer';
import Spinner from 'src/components/atoms/spinner/spinner';
import Flex from '../../atoms/flex/flex';

const Login = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { isAuthenticated, loading } = useAppSelector(state => state.authentication);

  const {
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: loginData,
  });

  const watchRememberMe = watch('rememberMe');

  const handleRememberMe = () => {
    setValue('rememberMe', !watchRememberMe);
  };

  const onSubmit = (data: LoginData) => {
    dispatch(doLogin(data));
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="container xs m-auto">
      <Form>
        <h2 className="mb-1">Accedi</h2>
        <FormRow>
          <FormItem>
            <input
              required
              autoComplete="off"
              className={`form-control ${errors.email ? 'is-invalid' : ''}`}
              type={'email'}
              placeholder="Email"
              {...register('email', validationSchema.email)}
            />
            <FormError error={errors.email} validation={validationSchema.email} />
          </FormItem>
        </FormRow>
        <FormRow>
          <FormItem>
            <input
              required
              autoComplete="off"
              className={`form-control ${errors.password ? 'is-invalid' : ''}`}
              type={'password'}
              placeholder="Password"
              {...register('password', validationSchema.required)}
            />
            <FormError error={errors.password} validation={validationSchema.required} />
          </FormItem>
        </FormRow>
        <FormRow>
          <FormItem>
            <Flex container gap={10} alignItems="center">
              <Switcher switched={watchRememberMe} onSwitch={handleRememberMe} /> Ricordami
            </Flex>
          </FormItem>
        </FormRow>
        <FormRow>
          <Button
            size="md"
            rounded="rounded-md"
            color="light-grey"
            mode="outline"
            fullWidth
            disabled={!isValid || loading}
            onClick={handleSubmit(onSubmit)}
          >
            {loading ? <Spinner /> : 'Invia'}
          </Button>
        </FormRow>
      </Form>
    </div>
  );
};

export default Login;
